module.exports = __webpack_public_path__ + "img/dashboard1.9060b7f4.png";